import {Stack, Typography} from "@mui/material";
import thousandSeparator from "../utils/NumberUtils";

const CompanyDetailSummary = ({partnerData}) => {

    const sumTotalSumTraffic = () => {
        let s = 0
        partnerData?.forEach(p => s += p?.total_sum_traffic)
        return s
    }

    const sumTotalSumMargin = () => {
        let s = 0
        partnerData?.forEach(p => s += p?.total_sum_margin)
        return s
    }

    const sumTotalCount = () => {
        let s = 0
        partnerData?.forEach(p => s += p?.total_sum_items)
        return s
    }

    const calculateMarginPercentage = () => {
        const traffic = sumTotalSumTraffic()
        const margin = sumTotalSumMargin()
        if (traffic === 0) return 0
        return ((margin / traffic) * 100).toFixed(2)
    }

    return <Stack marginBottom={3} className="gradient-card" spacing={1} marginTop={2}>
        <Typography variant="headline6">Összesen</Typography>
        <Typography variant="overline">Forgalom</Typography>
        <Typography variant="subtitle2">{thousandSeparator(sumTotalSumTraffic())} Ft</Typography>
        <Typography variant="overline">Árrés</Typography>
        <Typography variant="subtitle2">{thousandSeparator(sumTotalSumMargin())} Ft</Typography>
        <Typography variant="overline">Darabszám</Typography>
        <Typography variant="subtitle2">{thousandSeparator(sumTotalCount())} db</Typography>
        <Typography variant="overline">Forgalom arányos árrés</Typography>
        <Typography variant="subtitle2">{calculateMarginPercentage()}%</Typography>
    </Stack>;
}

export default CompanyDetailSummary